import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { FaLinkedinIn, FaYoutube, FaMedium } from 'react-icons/fa';

const team = [
  {
    name: 'Julien',
    role: 'Chief Marketing Officer',
    bio: 'Leads Evolution GEO’s go-to-market strategy. 10+ years in digital marketing, ecommerce growth, and performance campaigns across B2B and DTC.',
    links: {
      linkedin: '#'
    }
  },
  {
    name: 'Joseph',
    role: 'Automation Engineer & Developer',
    bio: 'Builds the automations behind GEO/AIO—workflows for lead capture, content generation, reporting, and integrations with your existing stack.',
    links: {
      linkedin: '#',
      youtube: '#',
      medium: '#'
    }
  },
  {
    name: 'Cyril',
    role: 'SEO & GEO/AIO Strategist',
    bio: 'Specializes in technical SEO and generative engine optimization—aligning site architecture, content, and authority with how AI systems choose sources.',
    links: {
      linkedin: '#'
    }
  },
  {
    name: 'Olga',
    role: 'Head of Sales & Partnerships',
    bio: 'Leads client relationships and partnerships. Turns GEO/AIO plans into clear engagement models and ensures teams stay aligned on outcomes.',
    links: {
      linkedin: '#'
    }
  }
];

export const Team = () => {
  return (
    <div className="min-h-screen pb-20">
      {/* Header */}
      <section className="pt-24 lg:pt-32 pb-12 lg:pb-20 bg-muted/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold mb-6">
            Meet the <span className="text-gradient">Evolution GEO</span> Team
          </h1>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            A small, senior team combining GEO/AIO strategy, technical execution, and sales enablement to help you win in AI search.
          </p>
        </div>
      </section>

      {/* Team grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-4">
            {team.map((member) => (
              <Card key={member.name} className="border-border bg-card/80 h-full flex flex-col">
                <CardHeader className="flex flex-col items-center">
                  <div className="w-20 h-20 mb-4 rounded-xl bg-muted flex items-center justify-center text-muted-foreground text-sm">
                    Image
                  </div>
                  <CardTitle className="font-display text-xl mb-1 text-center">
                    {member.name}
                  </CardTitle>
                  <p className="text-sm text-primary font-medium text-center">{member.role}</p>
                </CardHeader>
                <CardContent className="flex-1 flex flex-col">
                  <p className="text-sm text-muted-foreground mb-4">{member.bio}</p>
                  <div className="mt-auto flex items-center justify-between pt-2">
                    <div className="flex gap-2">
                      {member.links.linkedin && (
                        <a
                          href={member.links.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-8 h-8 rounded-md border border-border bg-background flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                          aria-label={`${member.name} on LinkedIn`}
                        >
                          <FaLinkedinIn size={14} />
                        </a>
                      )}
                      {member.links.youtube && (
                        <a
                          href={member.links.youtube}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-8 h-8 rounded-md border border-border bg-background flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                          aria-label={`${member.name} on YouTube`}
                        >
                          <FaYoutube size={14} />
                        </a>
                      )}
                      {member.links.medium && (
                        <a
                          href={member.links.medium}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-8 h-8 rounded-md border border-border bg-background flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                          aria-label={`${member.name} on Medium`}
                        >
                          <FaMedium size={14} />
                        </a>
                      )}
                    </div>
                    <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary">
                      <ArrowRight className="w-4 h-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

